import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";
import { getCartByWebUserId } from "../../api/website/Addtocartapi";
// cart product count
export const cartProductCount = createAsyncThunk("client/cart-product-count", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  console.log("data", data);

  try {
    const response = await axios.post(`${baseUrl}webapp/cart/api/v1/cart-count/${data}`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("cart product count response ", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in cart product count");
  }
});

// get cart product

// export const getCartProducts = createAsyncThunk("client/get-item-cart", async (data, { rejectWithValue }) => {
//   const token = localStorage.getItem("authToken");
//   const rowid = localStorage.getItem("UserRowId");
//   // let guestId = Cookies.get("guest_id");

//   try {
//     const response = await axios.post(
//       `${baseUrl}backend_function/admin/addToCart/api/v1/carts-list`,{},
//       // { guestId: guestId },
//       {
//         // headers: {
//         //   "auth-token": token,
//         // },
//          headers: {
//         Authorization: `Bearer ${token}`,
//       }
//       }
//     );
//     console.log("get cart products response ", response);
//     return response; // ✅ Return only the data
//   } catch (error) {
//     console.error("Error fetching products:", error);

//     // ✅ Handle errors properly
//     return rejectWithValue(error.response?.data?.message || "error in get cart products");
//   }
// });


export const getCartProducts = createAsyncThunk("client/get-item-cart", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  const userId = localStorage.getItem("UserRowId");
  // let guestId = Cookies.get("guest_id");

  try {
    const response = await axios.post(
      `${baseUrl}admin/addToCart/api/v1/carts-list`,{},
      // { guestId: guestId },
      {
        headers: {
          "auth-token": token,
        },
      //    headers: {
      //   Authorization: `Bearer ${token}`,
      // }
      }
    );
    console.log("get cart products response ", response.data);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "error in get cart products");
  }
});



export const getCartProductsWebuser = createAsyncThunk(
  "CartProducts/getCartProductsWebuser", // Make sure this matches the slice name
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCartByWebUserId();
      console.log("getCartProductsWebuser response:", response);
       return {
        data: response?.data || response
      };
    } catch (error) {
      console.error("Error in getCartProductsWebuser:", error);
      return rejectWithValue(error.response?.data?.message || "Failed to fetch cart");
    }
  }
);

// export const getCartProductsWebuser = createAsyncThunk(
//   "client/get-item-cart", 
//   async (userId, { rejectWithValue }) => {
//     const token = localStorage.getItem("authToken");
//     const rowid = userId || localStorage.getItem("UserRowId");
    
//     if (!rowid) {
//       return rejectWithValue("User ID not found");
//     }

//     try {
//       const response = await axios.post(
//         `${baseUrl}admin/addToCart/api/v1/cart-details-by-webuserId/${rowid}`,
//         {},
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           }
//         }
//       );
      
//       console.log("getCartProductsWebuser response ", response);
      
//       // If the response indicates empty cart, return empty array instead of rejecting
//       if (response.data?.message === "No cart list is found" || !response.data?.data) {
//         return { 
//           success: true, 
//           data: [], 
//           message: "Cart is empty",
//           cart: { products: [] } // Add this structure for your component
//         };
//       }
      
//       return response.data;
      
//     } catch (error) {
//       console.error("Error fetching products:", error);
      
//       // Check if it's the "no cart" error from backend
//       if (error.response?.data?.message === "No cart list is found") {
//         return { 
//           success: true, 
//           data: [], 
//           message: "Cart is empty",
//           cart: { products: [] }
//         };
//       }
      
//       return rejectWithValue(
//         error.response?.data?.message || "error in get cart products"
//       );
//     }
//   }
// );